import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Tooltip, IconButton, InputBase } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseArticleGroups } from "./UseArticleGroups";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import DeleteRow from "../../components/DeleteRow";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import CachedIcon from "@mui/icons-material/Cached";

export default function ArticleGroups() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const { GetArticleGroups, DeleteArticleGroup, ResetCache } =
    UseArticleGroups();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [pageState, setPageState] = useState({
    page: location.state && location.state.page ? location.state.page : 1,
  });
  const [writerRes, setWriterRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const [searchSubGroup, setSearchSubGroup] = useState("");
  const [filt, setFilt] = useState([]);

  useEffect(() => {
    setProgress(true);
    GetArticleGroups(true, (writers) => {
      setWriterRes(writers);
    });
  }, []);

  useEffect(() => {
    setFilt([
      {
        columnField: "author",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  const newFunc = () => {
    return navigate("/articlegroups/addArticleGroup", {
      state: {
        search: searchSubGroup,
        page: 2,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "faName",
      headerName: "نام فارسی",
      width: 220,
      align: "left",
      headerAlign: "center",
    },
    {
      field: "enName",
      headerName: "نام لاتین",
      width: 220,
      align: "right",
      headerAlign: "center",
    },
    {
      field: "description",
      headerName: "توضیحات",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.description ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 140,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box>
            <Tooltip title="Delete">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.faName,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  return navigate("/articlegroups/editArticleGroup", {
                    state: {
                      page: pageState.page,
                      search: search,
                      id: cellValues.row.id,
                    },
                  });
                }}
              >
                <EditIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="ریست کش">
              <IconButton
                sx={{ p: 0, m: 1 }}
                onClick={() => {
                  setProgress(true);
                  ResetCache(cellValues.row.id, () => {
                    setProgress(false);
                  });
                }}
              >
                <CachedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={search}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                setSearchSubGroup(evt.target.value);
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [{ name: msActiveMenu.pageTitle, url: "/articlegroups" }],
      }}
    >
      {writerRes ? (
        <DataGrid
          className="ltr-grid"
          disableVirtualization
          filterModel={{
            items: filt,
          }}
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rows={writerRes.groups}
          page={pageState.page - 1}
          pageSize={20}
          Pagination
          onPageChange={(newPage) => {
            setPageState((old) => ({ ...pageState, page: newPage + 1 }));
          }}
          rowCount={
            writerRes && writerRes.groups.length ? writerRes.groups.length : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              newFunc: newFunc,
              isLtr: true,
              rowCount: writerRes.groups.length ? writerRes.groups.length : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: "id",
                  sort: "asc",
                },
              ],
            },
          }}
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"گروه مقاله"}
        callback={() => {
          setProgress(true);
          DeleteArticleGroup(deleteState.id, () => {
            GetArticleGroups(true, (writers) => {
              setWriterRes(writers);
            });
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}
